import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { HomePage } from './pages/HomePage';
import { InventoryPage } from './pages/InventoryPage';
import { DeviceDetailPage } from './pages/DeviceDetailPage';
import { ClientSelectPage } from './pages/ClientSelectPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { DuplicatesPage } from './pages/DuplicatesPage';
import { AuditPage } from './pages/AuditPage';
import { UsersPage } from './pages/UsersPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <HomePage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventaire"
            element={
              <ProtectedRoute>
                <Layout>
                  <InventoryPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/:sn"
            element={
              <ProtectedRoute>
                <Layout>
                  <DeviceDetailPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <Layout>
                  <ClientSelectPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients/:uuid"
            element={
              <ProtectedRoute>
                <Layout>
                  <ClientDetailPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/audit"
            element={
              <ProtectedRoute>
                <Layout>
                  <AuditPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/doublons/:env/:deviceId"
            element={
              <ProtectedRoute>
                <Layout>
                  <DuplicatesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/utilisateurs"
            element={
              <ProtectedRoute>
                <Layout>
                  <UsersPage />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
